// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
}
.footer .record-count {
  font-size: 12px;
  font-weight: 300;
}
.footer .myproject-action-buttons {
  display: flex;
}
.footer .myproject-action-buttons .saveBtn {
  padding: 10px 24px;
  color: #fff;
  border: none;
  margin-right: 10px;
}
.footer .myproject-action-buttons .saveBtn:disabled {
  background-color: #acacac !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}
.footer .myproject-action-buttons .cancelBtn {
  background-color: #fff !important;
  color: #003da5;
  border: 1px solid #003da5;
  padding: 10px 24px;
}
.footer .myproject-action-buttons .cancelBtn:disabled {
  background-color: #f5f5f5 !important;
  color: #999 !important;
  border: 1px solid #acacac !important;
  cursor: not-allowed !important;
  opacity: 0.6;
}

.adjustTop {
  top: -25px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/tableFooter/index.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AACJ;AAGI;EACI,eAAA;EACA,gBAAA;AADR;AAII;EACI,aAAA;AAFR;AAIQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAFZ;AAIY;EACI,oCAAA;EACA,8BAAA;EACA,YAAA;AAFhB;AAMQ;EACI,iCAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAJZ;AAMY;EACI,oCAAA;EACA,sBAAA;EACA,oCAAA;EACA,8BAAA;EACA,YAAA;AAJhB;;AAUA;EACI,UAAA;AAPJ","sourcesContent":[".footer {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    padding: 0 15px;\n\n    \n\n    .record-count {\n        font-size: 12px;\n        font-weight: 300;\n    }\n\n    .myproject-action-buttons {\n        display: flex;\n\n        .saveBtn {\n            padding:10px 24px;\n            color: #fff;\n            border: none;\n            margin-right: 10px;\n            \n            &:disabled {\n                background-color: #acacac !important;\n                cursor: not-allowed !important;\n                opacity: 0.6;\n            }\n        }\n\n        .cancelBtn {\n            background-color: #fff !important;\n            color: #003da5;\n            border: 1px solid #003da5;\n            padding: 10px 24px;\n            \n            &:disabled {\n                background-color: #f5f5f5 !important;\n                color: #999 !important;\n                border: 1px solid #acacac !important;\n                cursor: not-allowed !important;\n                opacity: 0.6;\n            }\n        }\n    }\n}\n\n.adjustTop {\n    top: -25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
